// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../common/SelectInput/SelectDropdown.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReferenceNumberField {
  height: 40px;
}
.ReferenceNumberField__label {
  width: 50%;
  height: 100%;
  float: left;
}
.ReferenceNumberField__label-dropdown {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  height: 100%;
}
.ReferenceNumberField__label-text {
  white-space: nowrap;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  line-height: 20px;
  max-width: calc(100% - 25px);
  padding-right: 16px;
  margin-right: 4px;
  overflow: hidden;
  font-weight: 700;
  font-size: 14px;
  color: #002E33;
  text-overflow: ellipsis;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: 10px;
  background-position: right;
  cursor: pointer;
}
.ReferenceNumberField__label-text.open {
  color: #002E33;
}
.ReferenceNumberField__label .CSSToolTip {
  margin-right: 3px;
  margin-left: auto;
}
.ReferenceNumberField__label-menu-container {
  background-color: white !important;
  margin-left: 0px !important;
  padding: 12px 0 16px 0;
  border-radius: 2px;
  -webkit-box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
  overflow-y: auto;
  margin-top: 2px;
  position: relative;
  z-index: 1000;
}
.ReferenceNumberField__label-menu-item {
  line-height: 1.5em !important;
  padding: 6px 6px 6px 20px !important;
  color: #697588;
  cursor: pointer;
  font-size: 12px;
  overflow: hidden;
  font-weight: 500;
}
.ReferenceNumberField__label-menu-item:hover, .ReferenceNumberField__label-menu-item.selected {
  background-color: #F5F6F9 !important;
}
.ReferenceNumberField__input {
  margin-left: 0% !important;
  width: 50%;
  float: left;
  /* Hide arrows in the number input*/
  /* Chrome, Safari, Edge, Opera */
  /* Firefox */
}
.ReferenceNumberField__input input.invalid {
  border: 1px solid #D92D20 !important;
  color: #D92D20 !important;
}
.ReferenceNumberField__input input::-webkit-outer-spin-button,
.ReferenceNumberField__input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}
.ReferenceNumberField__input input[type=number] {
  -moz-appearance: textfield;
}
.ReferenceNumberField__input-invalid-msg {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #D92D20 !important;
}
.ReferenceNumberField__input-invalid-msg-inner {
  position: absolute;
  top: -28px;
  left: calc(100% + 20px);
  width: 200%;
}`, "",{"version":3,"sources":["webpack://./src/client/components/invoiceEditor/InvoiceHeader/ReferenceNumberField.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;AADF;AAGE;EACE,UAAA;EACA,YAAA;EACA,WAAA;AADJ;AAGI;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,uBAAA;MAAA,oBAAA;UAAA,2BAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,YAAA;AADN;AAKI;EACE,mBAAA;EACA,uBAAA;MAAA,oBAAA;UAAA,2BAAA;EACA,iBAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cC1BS;ED2BT,uBAAA;EACA,oEAAA;EACA,qBAAA;EACA,0BAAA;EACA,eAAA;AAHN;AAKM;EACE,cClCO;AD+Bf;AAOI;EACE,iBAAA;EACA,iBAAA;AALN;AAQI;EACE,kCAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,wDAAA;UAAA,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;AANN;AASI;EACE,6BAAA;EACA,oCAAA;EACA,cCPG;EDQH,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAPN;AASM;EAEE,oCAAA;AARR;AAaE;EACE,0BAAA;EACA,UAAA;EACA,WAAA;EAOA,mCAAA;EACA,gCAAA;EAQA,YAAA;AAxBJ;AAUI;EACE,oCAAA;EACA,yBAAA;AARN;AAaI;;EAEE,wBAAA;EACA,gBAAA;EACA,SAAA;AAXN;AAeI;EACE,0BAAA;AAbN;AAgBI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAdN;AAgBM;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;AAdR","sourcesContent":["@import\"../../../Global/Colors.scss\";\n\n.ReferenceNumberField {\n  height: 40px;\n\n  &__label {\n    width: 50%;\n    height: 100%;\n    float: left;\n\n    &-dropdown {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      height: 100%;\n\n    }\n\n    &-text {\n      white-space: nowrap;\n      justify-content: flex-start;\n      line-height: 20px;\n      max-width: calc(100% - 25px);\n      padding-right: 16px;\n      margin-right: 4px;\n      overflow: hidden;\n      font-weight: 700;\n      font-size: 14px;\n      color: $DeepSeaGreen;\n      text-overflow: ellipsis;\n      background: url(../../common/SelectInput/SelectDropdown.svg) no-repeat center;\n      background-size: 10px;\n      background-position: right;\n      cursor: pointer;\n\n      &.open {\n        color: $DeepSeaGreen;\n      }\n    }\n\n    .CSSToolTip {\n      margin-right: 3px;\n      margin-left: auto;\n    }\n\n    &-menu-container {\n      background-color: white !important;\n      margin-left: 0px !important;\n      padding: 12px 0 16px 0;\n      border-radius: 2px;\n      box-shadow: 0 10px 15px 0 rgba($Gray200, 0.15);\n      overflow-y: auto;\n      margin-top: 2px;\n      position: relative;\n      z-index: 1000;\n    }\n\n    &-menu-item {\n      line-height: 1.5em !important;\n      padding: 6px 6px 6px 20px !important;\n      color: $Gray90;\n      cursor: pointer;\n      font-size: 12px;\n      overflow: hidden;\n      font-weight: 500;\n\n      &:hover,\n      &.selected {\n        background-color: $Gray20 !important;\n      }\n    }\n  }\n\n  &__input {\n    margin-left: 0% !important;\n    width: 50%;\n    float: left;\n\n    input.invalid {\n      border: 1px solid $Red !important;\n      color: $Red !important;\n    }\n\n    /* Hide arrows in the number input*/\n    /* Chrome, Safari, Edge, Opera */\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      appearance: none;\n      margin: 0;\n    }\n\n    /* Firefox */\n    input[type=number] {\n      -moz-appearance: textfield;\n    }\n\n    &-invalid-msg {\n      position: relative;\n      font-size: 14px;\n      font-weight: 500;\n      color: $Red !important;\n\n      &-inner {\n        position: absolute;\n        top: -28px;\n        left: calc(100% + 20px);\n        width: 200%;\n      }\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
